<template>
  <div class="app-container">
    <span class="title">订单编号：</span>
    <div class="content">
      <div>下单时间：{{user.createdDate}}</div>
      <div>订单状态：{{user.orderState}}</div>
      <div>备注：{{user.beiz}}</div>
    </div>
    <span class="title">预约信息</span>
    <div class="content">
      <div>预约时间：{{user.yysj | formatDateTimeDefault}}</div>
      <div>客户：{{user.yhmc}}</div>
      <div>联系电话：{{user.yddh}}</div>
      <div>地址：{{user.sfen + user.cshi + user.xian + user.xzhen + user.dizi}}</div>
    </div>
    <span class="title">商品信息</span>
    <div class="content">
      <div>类目：{{user.goodsType}}</div>
      <div>规格：{{user.goodsNorms}}</div>
      <div>型号：{{user.goodsModel}}</div>
      <div>楼层：{{user.floor}}</div>
      <div>是否拆机：{{user.dismantle}}</div>
      <div>预估价格：{{user.money}}</div>
    </div>
    <div class="btnBack">
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      user: {}
    }
  },
  created() {
    console.log(this.$route, "rpiter")
    this.getList()
  },
  methods: {
    getList() {
      let params = {
        orderId: this.$route.query.id,
        key: this.$route.query.key,
      }
      let url = this.$route.query.type ? `/autoapp-default-server-recovery/api/tblRecycleOrder/getOrderImportById?id=${params.orderId}&key=${params.key}` : `/autoapp-default-server-recovery/api/recoveryOrder/getWdOrderImportById?id=${params.orderId}&key=${params.key}`
      this.HttpService.get(url, params).then(res => {
        this.user = res.data
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
}
.content {
  margin: 30px;
  div {
    margin-bottom: 16px;
  }
}
.btnBack {
  margin-left: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderCheck.vue